<template>
  <Section
    id="shiment-workflow-rules-section"
    :header="t('shipments.workflowRules', 2)"
    class="shiment-workflow-rules-section"
    data-class="shiment-workflow-rules-section-data"
  >
    <div class="row">
      <div v-for="rule in workflowRules" :key="rule.key" class="cell">
        <KeyValuePair
          :label="rule.label"
          :value="getValue(rule)"
          uppercase-label
        >
          <template #value>
            {{ getValue(rule) }}
            <InfoIcon icon="pi pi-info-circle" :tooltip="rule.helpText" />
          </template>
        </KeyValuePair>
      </div>
    </div>
  </Section>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { renderBoolean } from '@rygen/rygen-ui/i18n';

import { Shipment, WorkflowRule } from '@/model';

import InfoIcon from '@rygen/rygen-ui/components/ui/InfoIcon.vue';
import KeyValuePair from '@rygen/rygen-ui/components/ui/KeyValuePair.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const props = defineProps({
  shipment: {
    type: Shipment,
    default: () => new Shipment(),
  },
  workflowRules: {
    type: Array as PropType<WorkflowRule[]>,
    default: () => [],
  },
});
const { shipment, workflowRules } = toRefs(props);

const { t } = useI18n();

const getValue = (workflowRule: WorkflowRule): string | undefined => {
  let value = workflowRule.cachedValue;
  if (value === undefined) {
    value = workflowRule.getValue(shipment);
    workflowRule.cachedValue = value;
  }

  if (typeof value === 'boolean') {
    return renderBoolean(value);
  }
};
</script>

<style>
.shiment-workflow-rules-section {
  .shiment-workflow-rules-section-data {
    .row {
      display: flex;
      gap: var(--sp-3);

      .cell {
        flex: 1 0 auto;
        width: 50%;

        .key-value-pair-value {
          display: flex;
          align-items: center;
          gap: var(--sp-1);
        }
      }
    }
  }
}
</style>
